import React from "react";
import supervisedIcon from "../../../assets/test-new/supervisedIcon.svg";
import "./TopButtons.css";
import { Button } from "react-bootstrap";
import ReactTooltip from 'react-tooltip';

const SupervisedButton = ({ onClick, variant }) => {
  return (
    <>
      <Button
        className="top-buttons-frame"
        onClick={onClick}
        variant={variant}
        data-tip="Supervised"
        data-for="supervised-tooltip"
      >
        <img
          className="material-symbols"
          alt="Supervised"
          src={supervisedIcon}
        />
      </Button>

      <ReactTooltip id="supervised-tooltip" place="top" effect="solid" />
    </>
  );
};

export default SupervisedButton;
